import { List, Row, Col, Card, Divider } from "antd"
import React from "react"
import styles from "./CancellationPolicy.module.css"
import { Text, Title } from "ui/Typography"

const guestPolicy = [
  {
    title: "More than 48 hours before departure",
    content: [
      <span key="g1">
        Guests are eligible for a <strong>full refund</strong>, including any <strong>deposit</strong> paid.
      </span>
    ]
  },
  {
    title: "Between 24 to 48 hours before departure",
    content: [
      <span key="g2">
        The <strong>deposit is non-refundable</strong>, but the remaining balance will be refunded in full.
      </span>,
      <span key="g3">
        If the guest's card has not yet been charged, <strong>no charge will be applied.</strong>
      </span>
    ]
  },
  {
    title: "Less than 24 hours before departure",
    content: [
      <span key="g4">
        <strong>No refund</strong> will be issued.
      </span>,
      <span key="g5">A notification will be sent to the guest confirming the cancellation and refund status.</span>
    ]
  }
]

const proPolicy = [
  {
    title: "At any time (including less than 24 hours before departure)",
    content: [
      <span key="p1">
        Guests will receive a <strong>full refund</strong>, including any <strong>deposit</strong> paid.
      </span>
    ]
  }
]

const weatherPolicy = [
  <span key="w1">
    The same refund rules (like in the cases when guests cancel) as outlined above will apply based on the timing of the cancellation.
  </span>,
  <span key="w2">
    <strong>Alternatively</strong>, guides will be given the <strong>option to reschedule</strong> the trip instead of providing a refund.
  </span>
]

const notes = [
  <Text key="n1" strong>
    Bookings via the DS Guide marketplace.
  </Text>,
  <Text key="n2" strong>
    Bookings via embedded widgets on Guide's external websites.
  </Text>,
  <Text key="n3" strong>
    Bookings made manually by Guides for offline/walk-in customers.
  </Text>
]

const CancellationPolicyPage = () => (
  <Row justify="center" className={styles.container}>
    <Col xs={24} sm={22} md={18} lg={16} xl={14} className={styles.col}>
      <Card className={styles.card}>
        <Title level={1} className={styles.title1}>
          Cancellation & Refund Policy
        </Title>
        <Divider />

        <Title level={3} className={styles.title3}>
          1. If the Guest Cancels:
        </Title>
        <List
          itemLayout="vertical"
          dataSource={guestPolicy}
          renderItem={(item) => (
            <List.Item>
              <Text strong>{item.title}</Text>
              {Array.isArray(item.content) && item.content.length > 1 ? (
                <List
                  size="small"
                  dataSource={item.content}
                  renderItem={(point) => <List.Item className={styles.listNoBorder + " " + styles.listIndented}>{point}</List.Item>}
                />
              ) : (
                <div className={styles.listIndented}>{item.content}</div>
              )}
            </List.Item>
          )}
        />

        <Title level={3} className={styles.title3} style={{ marginTop: 32 }}>
          2. If the Pro Cancels:
        </Title>
        <List
          itemLayout="vertical"
          dataSource={proPolicy}
          renderItem={(item) => (
            <List.Item>
              <Text strong>{item.title}</Text>
              {Array.isArray(item.content) && item.content.length > 1 ? (
                <List
                  size="small"
                  dataSource={item.content}
                  renderItem={(point) => <List.Item className={styles.listNoBorder + " " + styles.listIndented}>{point}</List.Item>}
                />
              ) : (
                <div className={styles.listIndented}>{item.content}</div>
              )}
            </List.Item>
          )}
        />

        <Title level={3} className={styles.title3} style={{ marginTop: 32 }}>
          Cancellations Due to Bad Weather (Guest or Pro Initiated):
        </Title>
        <List
          itemLayout="vertical"
          dataSource={weatherPolicy}
          renderItem={(item) =>
            Array.isArray(item) && item.length > 1 ? (
              <List
                size="small"
                dataSource={item}
                renderItem={(point) => <List.Item className={styles.listNoBorder + " " + styles.listIndented}>{point}</List.Item>}
              />
            ) : (
              <div className={styles.listNoBorder + " " + styles.listIndented}>{item}</div>
            )
          }
        />

        <Title level={4} className={styles.title3} style={{ marginTop: 32 }}>
          Note:
        </Title>
        <List
          size="small"
          dataSource={notes}
          renderItem={(point) => <List.Item className={styles.listNoBorder + " " + styles.listIndented}>{point}</List.Item>}
        />
      </Card>
    </Col>
  </Row>
)

export default CancellationPolicyPage
